// import 'server-only'; use when next sanity preview kit is updated

import type {QueryParams} from '@sanity/client';

import {client} from './sanity.client';

interface QueuedFetch {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	resolve: (value: any) => void;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	reject: (reason?: any) => void;
	query: string;
	params?: QueryParams;
}

let fetchQueue: QueuedFetch[] = [];

// processFetchQueue processes all queued fetches in the global fetchFQueue.
// It takes special care to also process fetches added to the queue
// asynchronously while it was processing a fetch. Once done it clears the
// fetch queue.
async function processFetchQueue() {
	for (let i = 0; i < fetchQueue.length; ++i) {
		const queuedFetch = fetchQueue[i];

		try {
			const result = await client.fetch(queuedFetch?.query, queuedFetch?.params);
			queuedFetch.resolve(result);
		} catch (e) {
			queuedFetch.reject(e);
		}
	}

	fetchQueue = [];
}

interface SanityFetchParams {
	query: string;
	params?: QueryParams;
}

// sanityFetch performs a fetch reuqest against Sanity. It takes special care to
// serialize the fetch requests to avoid overloading the Sanity API and exceed their
// API rate limits.
export const sanityFetch = async <T>({query, params}: SanityFetchParams) => {
	return new Promise<T>((resolve, reject) => {
		fetchQueue.push({
			resolve,
			reject,
			query,
			params,
		});

		if (fetchQueue.length === 1) {
			processFetchQueue();
		}
	});
};
